<div>{{ environment.store }}</div>
<img [src]="environment.flag" />
